module.exports = {"540235100":"聂拉木镇","540235101":"樟木镇","540235200":"亚来乡","540235201":"锁作乡","540235202":"乃龙乡","540235203":"门布乡","540235204":"波绒乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/540235.json
// module id = 2838
// module chunks = 0